class ProductController {
    constructor() {
      // Gallery first so thumbs work even when the add-to-cart form is absent (info mode)
      this.initializeAllSwipers();
      this.initializeVariables();
      this.setupEventListeners();
      this.setupSellingPlanListeners();
    }
  
    initializeVariables() {
      // Price elements
      this.priceElement = document.querySelector(".price-actual");
      this.compareAtPrice = document.querySelector(".price-compare");
      this.basePrice = this.getPriceValue(this.priceElement);
  
      // In initializeVariables()
      this.purchaseOptions = document.querySelectorAll(
        'input[name="purchaseOption"]'
      );
      this.onetimeRadio = document.querySelector("#rc-radio1");
      this.subscriptionRadio = document.querySelector("#rc-radio2");
      this.sellingPlanText = document.querySelector(".rc-selling-plans-single");
  
      // Variant elements
      this.variantWrapper = document.querySelector("[data-variant-wrapper]");
      this.optionSelectors = document.querySelectorAll("[data-option-selector]");
  
      // Form elements (may be missing in info / where-to-buy mode)
      this.form = document.querySelector(`form[data-product-form]`);
      this.addToCartButton = document.querySelector("[data-add-to-cart]");
      this.variantIdInput = document.querySelector("[data-variant-id]");
      this.sellingPlanInput = this.form?.querySelector('[name="selling_plan"]');
      this.loadingSpinner = document.querySelector(".loading-overlay__spinner");
  
      // Selling plan elements
      this.purchaseOptions = document.querySelectorAll(
        "[data-selling-plan-group]"
      );
      this.sellingPlanSelect = document.querySelector(
        "[data-selling-plan-select]"
      );
  
      // Quantity elements
      this.quantityInput = document.querySelector("[data-quantity-input]");
      this.quantityPlus = document.querySelector("[data-quantity-plus]");
      this.quantityMinus = document.querySelector("[data-quantity-minus]");
  
      // Cart notification
      this.cartNotification = this.createCartNotification();
      document.body.appendChild(this.cartNotification);
  
      // Get variants data
      this.variants = window.productVariants || [];
  
      // Check URL for variant ID
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get("variant");
  
      // Initial variant setup
      this.updateAllVariantSelectors();
  
      // Ensure the correct variant is selected (skip when no form / variant input)
      if (this.variantIdInput) {
        if (variantIdFromUrl) {
          const variantFromUrl = this.variants.find(v => v.id.toString() === variantIdFromUrl);
          if (variantFromUrl) {
            this.variantIdInput.value = variantFromUrl.id;
            this.basePrice = variantFromUrl.price / 100;
            this.updatePrice(1);
            this.updateAddToCartButton(variantFromUrl.available);
            console.log("Variant selected from URL:", variantFromUrl.id);
          }
        } else if (!this.variantIdInput.value && this.variants.length > 0) {
          const firstVariant = this.variants[0];
          this.variantIdInput.value = firstVariant.id;
          this.basePrice = firstVariant.price / 100;
          this.updatePrice(1);
          this.updateAddToCartButton(firstVariant.available);
          console.log("Default variant selected:", firstVariant.id);
        }
      }
  
      // Cart state
      this.isAddingToCart = false;
    }
  
    getPriceValue(element) {
      if (!element) return 0;
      return parseFloat(element.textContent.replace(/[^0-9.]/g, "")) || 0;
    }
  
    createCartNotification() {
      const notification = document.createElement("div");
      notification.className = "cart-notification";
      notification.style.cssText = `
        position: fixed;
        top: 0px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 16px 24px;
        border-radius: 4px;
        z-index: 1000;
        display: none;
        opacity: 0;
        transition: opacity 0.3s ease;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      `;
      return notification;
    }
  
    setupEventListeners() {
      // Handle form submission
      if (this.form) {
        this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
      }
  
      // Variant selection
      this.optionSelectors?.forEach((selector) => {
        if (selector.tagName === "SELECT") {
          selector.addEventListener("change", () => this.handleVariantChange());
        } else {
          const pills = selector.querySelectorAll('input[type="radio"]');
          pills.forEach((radio) => {
            radio.addEventListener("change", () => this.handleVariantChange());
          });
        }
      });
  
      // Quantity controls
      this.quantityPlus?.addEventListener("click", () => this.updateQuantity(1));
      this.quantityMinus?.addEventListener("click", () =>
        this.updateQuantity(-1)
      );
      this.quantityInput?.addEventListener("change", () =>
        this.handleQuantityChange()
      );
  
      // Listen for cart update events
      document.addEventListener("cart:update", this.updateCartUI.bind(this));
    }
    setupSellingPlanListeners() {
      // Clear any existing listeners first
      this.subscriptionRadio?.removeEventListener(
        "change",
        this.handleSubscriptionChange
      );
      this.onetimeRadio?.removeEventListener("change", this.handleOnetimeChange);
  
      // Add listeners to radio buttons
      const purchaseOptions = document.querySelectorAll(
        'input[name^="purchaseOption_template"]'
      );
  
      purchaseOptions.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          if (e.target.dataset.radioType === "selling_plan") {
            this.handleSubscriptionChange(e);
          } else {
            this.handleOnetimeChange(e);
          }
        });
      });
  
      // Set initial state (optional — not all product modes define this)
      if (typeof this.handleInitialState === "function") {
        this.handleInitialState();
      }
    }
  
    handleSubscriptionChange(e) {
      if (!e.target.checked) return;
  
      const sellingPlanId = e.target.dataset.sellingPlanId;
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = sellingPlanId;
        console.log("Set selling plan ID:", this.sellingPlanInput.value);
      } else {
        console.warn("Selling plan input not found");
      }
  
      // Update price to subscription price
      this.updatePrice(parseInt(this.quantityInput?.value) || 1);
    }
  
    handleOnetimeChange(e) {
      if (!e.target.checked) return;
  
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = "";
        console.log("Cleared selling plan ID");
      } else {
        console.warn("Selling plan input not found");
      }
  
      // Update price to regular price
      this.updatePrice(parseInt(this.quantityInput?.value) || 1);
    }
  
    handleFormSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
  
      if (this.isAddingToCart) return;
  
      this.handleAddToCart();
      return false;
    }
  
    async handleAddToCart() {
      if (!this.form || this.isAddingToCart) return;
  
      const quantity = parseInt(this.quantityInput?.value) || 1;
      const variantId = this.variantIdInput?.value;
      const sellingPlanId = this.sellingPlanInput?.value;
  
      if (!variantId) {
        this.showCartNotification("Please select a variant", "error");
        return;
      }
  
      // Store original button text and width
      const textSpan = this.addToCartButton.querySelector(".add-to-cart-text");
      const originalText = textSpan?.textContent || "";
      const originalWidth = this.addToCartButton.offsetWidth;
  
      this.isAddingToCart = true;
      this.addToCartButton.disabled = true;
      this.addToCartButton.style.width = `${originalWidth}px`; // Lock width
      if (textSpan) textSpan.textContent = "Adding to Cart...";
      this.loadingSpinner?.classList.remove("hidden");
  
      try {
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", quantity);
        if (sellingPlanId) {
          formData.append("selling_plan", sellingPlanId);
        }
  
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await response.json();
  
        // Update cart count and trigger cart update event
        this.updateCart();
  
        // Show success notification
        this.showCartNotification("Item added to cart successfully");
  
        // Update button text
        if (textSpan) textSpan.textContent = "Added to Cart!";
  
        // Trigger custom event
        document.dispatchEvent(
          new CustomEvent("cart:added", {
            detail: {
              variant: data,
              quantity: quantity,
              selling_plan: sellingPlanId,
            },
          })
        );
      } catch (error) {
        console.error("Error adding to cart:", error);
        this.showCartNotification(
          "There was an error adding to cart. Please try again.",
          "error"
        );
        // Reset button text on error
        if (textSpan) textSpan.textContent = originalText;
      } finally {
        this.loadingSpinner?.classList.add("hidden");
  
        // Reset button after 2 seconds
        setTimeout(() => {
          this.isAddingToCart = false;
          this.addToCartButton.disabled = false;
          this.addToCartButton.style.width = ""; // Remove fixed width
          if (textSpan) textSpan.textContent = originalText;
        }, 2000);
      }
    }
  
    async updateCart() {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
  
        if (!response.ok) throw new Error("Failed to fetch cart");
  
        const cart = await response.json();
  
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            detail: { cart },
          })
        );
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    }
  
    updateCartUI(event) {
      const cart = event.detail.cart;
  
      // Update any cart count elements
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count;
        element.classList.toggle("hidden", cart.item_count === 0);
      });
  
      if (this.quantityInput) {
        this.quantityInput.value = 1;
      }
      // Update items-counter span
      const itemsCounter = document.querySelector(".items-counter");
      if (itemsCounter) {
        itemsCounter.innerHTML = cart.item_count;
      }
    }
    showCartNotification(message, type = "success") {
      if (!this.cartNotification) return;
  
      this.cartNotification.textContent = message;
      this.cartNotification.style.background =
        type === "success" ? "#4CAF50" : "#f44336";
      this.cartNotification.style.display = "block";
  
      // Force reflow
      this.cartNotification.offsetHeight;
  
      this.cartNotification.style.opacity = "1";
  
      setTimeout(() => {
        this.cartNotification.style.opacity = "0";
        setTimeout(() => {
          this.cartNotification.style.display = "none";
        }, 300);
      }, 3000);
    }
  
    updateQuantity(change) {
      if (!this.quantityInput) return;
  
      const currentQty = parseInt(this.quantityInput.value) || 1;
      const newQty = Math.max(1, currentQty + change);
      this.quantityInput.value = newQty;
      this.updatePrice(newQty);
    }
  
    handleQuantityChange() {
      if (!this.quantityInput) return;
  
      const qty = parseInt(this.quantityInput.value) || 1;
      this.quantityInput.value = Math.max(1, qty);
      this.updatePrice(this.quantityInput.value);
    }
  
    updatePrice(quantity) {
      if (!this.priceElement) return;
  
      let price = this.basePrice;
      const selectedPurchaseType = document.querySelector(
        "[data-selling-plan-group]:checked"
      );
  
      if (
        selectedPurchaseType?.value === "subscription" &&
        this.sellingPlanSelect
      ) {
        const selectedOption =
          this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
        if (selectedOption?.dataset.price) {
          price = parseFloat(selectedOption.dataset.price);
        }
      }
  
      const total = price * quantity;
      const priceSpan =
        this.priceElement.querySelector("span") || this.priceElement;
      priceSpan.textContent = this.formatMoney(total);
  
      if (this.compareAtPrice) {
        const comparePrice = this.getPriceValue(this.compareAtPrice);
        const comparePriceSpan =
          this.compareAtPrice.querySelector("span") || this.compareAtPrice;
        comparePriceSpan.textContent = this.formatMoney(comparePrice * quantity);
      }
    }
  
    formatMoney(amount) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amount);
    }
  
    updateAllVariantSelectors() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");
  
      if (!variantId || !this.variants) return;
  
      const variant = this.variants.find((v) => v.id.toString() === variantId);
      if (!variant) return;
  
      variant.options.forEach((optionValue, index) => {
        const selector = this.optionSelectors[index];
        if (!selector) return;
  
        if (selector.tagName === "SELECT") {
          selector.value = optionValue;
        } else {
          const radio = selector.querySelector(`input[value="${optionValue}"]`);
          if (radio) {
            radio.checked = true;
            radio.closest(".variant-pill")?.classList.add("active");
          }
        }
      });
    }
  
    handleVariantChange() {
      if (!this.optionSelectors || !this.variants) return;
  
      const selectedOptions = Array.from(this.optionSelectors).map((selector) => {
        if (selector.tagName === "SELECT") {
          return selector.value;
        } else {
          const checkedRadio = selector.querySelector("input:checked");
          return checkedRadio ? checkedRadio.value : null;
        }
      });
  
      const selectedVariant = this.variants.find((variant) =>
        variant.options.every(
          (option, index) => option === selectedOptions[index]
        )
      );
  
      if (!selectedVariant) return;
  
      // Update form ID
      if (this.variantIdInput) {
        this.variantIdInput.value = selectedVariant.id;
      }
  
      // Update price
      this.basePrice = selectedVariant.price / 100;
      this.updatePrice(parseInt(this.quantityInput?.value) || 1);
  
      // reset quantity selection
      if (this.quantityInput) {
        this.quantityInput.value = 1;
      }
      // reset price
      this.updatePrice(1);
      // Update URL
      if (history.replaceState) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", selectedVariant.id);
        window.history.replaceState({ path: newUrl.href }, "", newUrl.href);
      }
  
      // Update variant pills styling
      this.updatePillsStyle();
  
      // Update variant image
      this.updateVariantImage(selectedVariant);
  
      // Update button state
      this.updateAddToCartButton(selectedVariant.available);
    }
  
    updateAddToCartButton(available) {
      if (!this.addToCartButton) return;
  
      this.addToCartButton.disabled = !available;
      const textSpan = this.addToCartButton.querySelector(".add-to-cart-text");
      if (textSpan && !this.isAddingToCart) {
        textSpan.textContent = available ? "Add to Cart" : "Sold Out";
      }
    }
  
    updatePillsStyle() {
      this.optionSelectors?.forEach((selector) => {
        if (selector.classList.contains("variant-pills")) {
          selector.querySelectorAll(".variant-pill").forEach((pill) => {
            const radio = pill.querySelector('input[type="radio"]');
            if (radio) {
              pill.classList.toggle("active", radio.checked);
            }
          });
        }
      });
    }
  
    updateVariantImage(variant) {
      if (!variant?.featured_image?.src) return;
  
      document.dispatchEvent(
        new CustomEvent("variant:changed", {
          detail: { variant },
        })
      );
    }
  
    initializeAllSwipers() {
      if (typeof Swiper === "undefined") {
        console.warn("Swiper is not loaded");
        return;
      }
  
      const isMobile = window.innerWidth < 1250;
  
      // Find all gallery containers
      const galleryContainers = document.querySelectorAll(".product-gallery");
  
      galleryContainers.forEach((galleryContainer) => {
        // Initialize swiper for each gallery container
        this.initializeSingleSwiper(galleryContainer, isMobile);
      });
  
      // Update visibility on resize
      window.addEventListener("resize", () => {
        const newIsMobile = window.innerWidth < 1250;
        if (newIsMobile !== isMobile) {
          location.reload(); // Reinitialize Swiper on breakpoint change
        }
      });
    }
  
    initializeSingleSwiper(galleryContainer, isMobile) {
      let thumbsSwiper;
  
      // Only initialize thumbs on desktop
      if (!isMobile) {
        const thumbsElement = galleryContainer.querySelector(".product-thumbs");
        if (thumbsElement) {
          thumbsSwiper = new Swiper(thumbsElement, {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
          });
        }
      }
  
      const mainElement = galleryContainer.querySelector(".product-swiper");
      if (!mainElement) return;
  
      const mainSwiper = new Swiper(mainElement, {
        spaceBetween: 10,
        navigation: {
          nextEl: mainElement.querySelector(".swiper-button-next"),
          prevEl: mainElement.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: mainElement.querySelector(".swiper-pagination"),
          clickable: true,
          renderBullet: (index, className) => {
            const dotSize = mainElement.dataset.dotSize || "12";
            const dotColor = mainElement.dataset.dotColor || "#FFFFFF";
            return `<span class="${className}" style="
              width: ${dotSize}px;
              height: ${dotSize}px;
              border: 2px solid ${dotColor};
              background: transparent;
              opacity: 1;
            "></span>`;
          },
        },
        // Only use thumbs on desktop
        thumbs: !isMobile && thumbsSwiper ? { swiper: thumbsSwiper } : null,
      });
  
      // Handle pagination visibility
      const paginationEl = mainElement.querySelector(".swiper-pagination");
      if (paginationEl) {
        paginationEl.style.display = isMobile ? "block" : "none";
      }
  
      // Handle thumbnails visibility
      const thumbsEl = galleryContainer.querySelector(".product-thumbs");
      if (thumbsEl) {
        thumbsEl.style.display = isMobile ? "none" : "block";
      }
  
      // Store swiper instance reference for variant changes
      mainElement.swiper = mainSwiper;
    }
  
    // Update the variant image handler to work with multiple swipers
    updateVariantImage(variant) {
      if (!variant?.featured_image?.src) return;
  
      document.querySelectorAll(".product-swiper").forEach((swiperElement) => {
        const slides = swiperElement.querySelectorAll(
          ".swiper-slide[data-variant-ids]"
        );
  
        const variantSlide = Array.from(slides).find((slide) => {
          const variantIds = slide.dataset.variantIds.split(",");
          return variantIds.includes(variant.id.toString());
        });
  
        if (variantSlide && swiperElement.swiper) {
          const slideIndex = Array.from(variantSlide.parentNode.children).indexOf(
            variantSlide
          );
          swiperElement.swiper.slideTo(slideIndex);
        }
      });
    }
  }
  
  // Initialize on DOM load
  document.addEventListener("DOMContentLoaded", () => {
    new ProductController();
  });
  